import { uniqBy } from 'lodash'
import { useContext, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { ConnectedUserContext } from '../../../misc/auth.utilities'
import { VISIBILITY_FILTER_SELECT_VALUES } from '../../../misc/filters.utils'
import { getFullName } from '../../../misc/user.utilities'
import { currentUserMeTeamsSelector } from '../../../store/domain/me'

export enum VisibilityLabel {
  Questionnaires = 'Mes questionnaires',
  Documents = 'Mes Documents',
}

export const useVisibilityOptions = (label: VisibilityLabel) => {
  const { currentUser } = useContext(ConnectedUserContext)
  const currentUserTeams = useSelector(currentUserMeTeamsSelector)

  const teamsOtherMembers = useMemo(
    () =>
      uniqBy(
        currentUserTeams.flatMap(({ memberUsers }) =>
          memberUsers
            .filter((member) => member.id !== currentUser?.id)
            .map((member) => ({ value: member.id, label: getFullName(member, true) })),
        ),
        'value',
      ),
    [currentUser?.id, currentUserTeams],
  )

  const options = useMemo(
    () =>
      currentUser
        ? [
            ...VISIBILITY_FILTER_SELECT_VALUES,
            { value: currentUser.id, label },
            ...teamsOtherMembers,
          ]
        : VISIBILITY_FILTER_SELECT_VALUES,
    [currentUser, teamsOtherMembers, label],
  )

  return options
}
